// Global
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { classnames } from 'tailwindcss-classnames';
// Components
import Container from 'components/helpers/Container';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { Components } from '.generated/templates/Feature.Components.model';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import { MissingDataSource } from 'components/helpers/EditingHelpText';

export type LayoutTwoColumnProps = Sitecore.Override.ComponentBase &
  Components.Layout.Fields.ColumnLayout;

export type LayoutTwoColumnShellProps = {
  left: JSX.Element;
  right: JSX.Element;
};

export const LayoutTwoColumnShell = ({ left, right }: LayoutTwoColumnShellProps): JSX.Element => {
  const rightPlaceholder = right.props.rendering?.placeholders['nmdp-half-width-right'];
  const rightPlaceholderIsEmpty = rightPlaceholder && rightPlaceholder.length === 0;

  return (
    <div className={classnames('md:grid', 'grid-cols-2', 'md:gap-5', 'lg:gap-7')}>
      <div
        className={classnames(
          { 'mb-10': !rightPlaceholderIsEmpty, 'mb-0': rightPlaceholderIsEmpty },
          'md:mb-0'
        )}
      >
        {left}
      </div>
      <div>{right}</div>
    </div>
  );
};

const LayoutTwoColumn = ({ rendering, fields }: LayoutTwoColumnProps): JSX.Element => {
  if (fields === null || fields === undefined) {
    return <MissingDataSource />;
  }

  const headingProps = propsFromFields(fields);

  return (
    <Container size="standard" dataComponent="authorable/layout/layout-two-column">
      <div className={fields?.description.value ? classnames('mb-8') : ''}>
        <Heading {...headingProps} descriptionClassName={classnames('text-base')} />
      </div>
      <LayoutTwoColumnShell
        left={<PlaceholderWrapper name="nmdp-half-width-left" rendering={rendering} />}
        right={<PlaceholderWrapper name="nmdp-half-width-right" rendering={rendering} />}
      />
    </Container>
  );
};

export default LayoutTwoColumn;
